import { actionTypes } from './constants';
import { apiCallStatus } from 'helpers/constants';

const initialState = {
    serialNumber: {
        singleDrive: {
            oldlSerialNumber: '',
            newSerialNumber: '',
            suffix: '',
            isMultiModuleDrive: false,
        },
        cabinetDrive: {
            oldSerialNumber: '',
            newSerialNumber: '',
            suffix: '',
            isMultiModuleDrive: false,
        }
    },
    validateSerialNumber: {
        loadingStatus: null,
        isValid: null,
        errorMessage: null
    }
};

function serialNumberEditorReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.VALIDATE_SERIAL_NUMBER_SETTINGS:
            return {
                ...state,
                validateSerialNumber: {
                    ...state.validateSerialNumber,
                    loadingStatus: action?.loadingStatus,
                    isValid: action?.loadingStatus === apiCallStatus.SUCCESS ? action.data?.isValid : null,
                    errorMessage: action?.loadingStatus === apiCallStatus.SUCCESS ? action.data?.errorMessage : null
                }
            };
        case actionTypes.VALIDATE_SERIAL_NUMBER_CLEAR:
            return {
                ...state,
                validateSerialNumber: {
                    ...initialState.validateSerialNumber
                }
            };
        default:
            return state;
    }
}

export { serialNumberEditorReducer as reducer };
